import React, {FunctionComponent, ReactNode, useMemo} from 'react';
import { KlButton } from '../klButton/klButton.component';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const styles = require('./klResponsiveDialog.component.scss');

export interface DialogTitleDefinitions {
    icon?: string;
    text: string;
}

interface KlDialogTitleProps {
    titleText?: ReactNode;
    secondaryTitle?: DialogTitleDefinitions | DialogTitleDefinitions[];
    dropdownIcon?: string;
    dropdownElement?: ReactNode;
    actionTitle?: DialogTitleDefinitions;
    onAction?: () => void;
    cancelText?: string;
    cancelClass?: string;
    onCancel?: () => void;
    hideCancel?: boolean;
    hideCancelText?: boolean;
    fixedCancel?: boolean;
    fullScreen?: boolean;
    fullScreenOnly?: boolean;
    className?: string;
    customBackgroundClass?: string;
    titleActions?: ReactNode;
    hideTitleBorder?: boolean;
}

export const KlDialogTitle: FunctionComponent<KlDialogTitleProps> = props => {
    const {
        titleText, secondaryTitle, dropdownIcon, dropdownElement, onCancel, actionTitle, onAction , fullScreen, fullScreenOnly, cancelText, cancelClass, hideCancel,
        hideCancelText, className, customBackgroundClass, fixedCancel, children, titleActions, hideTitleBorder} = props;
    if (fullScreenOnly && !fullScreen) return null;

    const secondaryTitleArray: Array<DialogTitleDefinitions> | null = useMemo(() => {
        if (!secondaryTitle) return null;
        return Array.isArray(secondaryTitle) ? secondaryTitle : [secondaryTitle];
    },[secondaryTitle]);

    const secondaryTitleText = useMemo(() => {
        return secondaryTitleArray ?
            (
                <div className={`${styles.secondaryTitleContainer} ${titleText ? styles.titleSeparator : ''}`}>
                    <div className={styles.secondaryTitleText}>
                        {secondaryTitleArray.map(({icon, text}, index) =>
                            <React.Fragment key={index}>
                                {icon && <i key={text} className={`${styles.secondaryIcon} ${icon}`}/>}
                                {text}
                            </React.Fragment>
                        )}
                    </div>
                </div>
            )
            : null;
    },[titleText, secondaryTitleArray]);

    return (
        <div className={`${styles.klDialogTitle} ${customBackgroundClass ?? styles.defaultBackground} ${fixedCancel ? styles.fixedCancel : ''} ${hideTitleBorder ? styles.noBorder : ''}`}>
            {titleText &&
            <div className={`${styles.titleText} ${className || ''} ${fullScreen ? styles.fullScreenTitle : ''}`}>
                {titleText}
            </div>
            }
            {secondaryTitleText}
            {(dropdownElement || dropdownIcon) &&
            <div className={`${styles.dropdownContainer} ${(titleText || secondaryTitleArray) ? styles.titleSeparator : ''}`}>
                {dropdownIcon && <i className={`${styles.dropdownIcon} ${dropdownIcon}`}/>}
                {dropdownElement}
            </div>
            }
            {(actionTitle && onAction) &&
            <div className={`${styles.actionContainer} ${(titleText || secondaryTitleArray || dropdownElement || dropdownIcon) ? styles.titleSeparator : ''}`}>
                <KlButton buttonType={'tertiary'} size={'medium'} text={actionTitle.text} leftIcon={actionTitle.icon}
                          onClick={onAction} className={styles.actionButton} noPadding/>
            </div>
            }
            <div className={styles.pushRight}/>
            {children}
            {titleActions &&
            <div className={styles.titleActionsContainer}>
                {titleActions}
            </div>
            }
            {(onCancel && !hideCancel) &&
            <>
                <div className={`${styles.titleButton} ${styles.titleCancel} ${cancelClass || ''}`} onClick={onCancel}>
                    <i className={`fas fa-times ${styles.titleButtonIcon}`}/>
                    {!hideCancelText && <span className={styles.titleCancelText}>{cancelText || 'Cancel'}</span>}
                </div>
            </>
            }
        </div>
    );
};
